import { LAST_PLAY_KEY, REDEEMED_KEY, RESET_STORAGE_TIME } from "../consts";

const localStorageUtils = {
    // Save data to localStorage
    setItem: (key, value) => {
        if (typeof window !== "undefined") {
            try {
                const serializedValue = JSON.stringify(value);
                localStorage.setItem(key, serializedValue);
                localStorage.setItem(LAST_PLAY_KEY, Date.now().toString());
            } catch (error) {
                console.error("Error saving to localStorage", error);
            }
        }
    },

    // Retrieve data from localStorage
    getItem: (key) => {
        if (typeof window !== "undefined") {
            try {
                const LastPlayValue = localStorage.getItem(LAST_PLAY_KEY);
                if (LastPlayValue) {
                    const timeDiff = Date.now() - parseInt(LastPlayValue);
                    if (timeDiff > RESET_STORAGE_TIME) {
                        localStorage.clear();
                        return null;
                    }
                }
                else {
                    localStorage.clear();
                    return null;
                }

                const serializedValue = localStorage.getItem(key);
                return serializedValue
                    ? JSON.parse(serializedValue)
                    : null;

            } catch (error) {
                console.error("Error reading from localStorage", error);
                return null;
            }
        }
        return null;
    },

    // Remove item from localStorage
    removeItem: (key) => {
        if (typeof window !== "undefined") {
            try {
                localStorage.removeItem(key);
            } catch (error) {
                console.error("Error removing from localStorage", error);
            }
        }
    },

    // Clear all data from localStorage
    clear: () => {
        if (typeof window !== "undefined") {
            try {
                localStorage.clear();
            } catch (error) {
                console.error("Error clearing localStorage", error);
            }
        }
    },

    // Check if a prize has been redeemed
    isRedeemed: () => {
        const redeemed = localStorageUtils.getItem(REDEEMED_KEY);
        return redeemed !== null && redeemed === true;
    },

    // Mark prize as redeemed
    markAsRedeemed: () => {
        localStorageUtils.setItem(REDEEMED_KEY, true);
    },

    // Remove redeemed status
    removeRedeemedStatus: () => {
        localStorageUtils.removeItem(REDEEMED_KEY);
    }
};

export default localStorageUtils;  